export default {
  SHOW_MODAL (state, { type, props }) {
    state.type = type
    state.props = props
  },
  HIDE_MODAL (state) {
    state.type = ''
    state.props = {}
  },
}
